// src/components/ProjectsGrid.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import ProjectCard from './ProjectCard';

const ProjectsGrid = () => {
  const navigate = useNavigate();

  const projects = [
    {
      id: 'panel',
      title: 'Panel de Control',
      description:
        'Sistema integral de monitoreo y control de procesos con indicadores y análisis en tiempo real.',
      image: '/images/PANEL.png',
      features: [
        'Monitoreo en tiempo real',
        'Alertas automáticas',
        'Reportes personalizados'
      ]
    },
    {
      id: 'mapeo',
      title: 'Sistema de Mapeo',
      description:
        'Geolocalización de plantas, proveedores y prospectos con análisis espacial y rutas optimizadas.',
      image: '/images/MAPEO.png',
      features: [
        'Mapeo interactivo',
        'Cobertura geográfica',
        'Rutas optimizadas'
      ]
    },
    {
      id: 'cubo',
      title: 'Cubo Comercial',
      description:
        'Inteligencia comercial para análisis multidimensional, KPIs y predicción de ventas.',
      image: '/images/CUBO.png',
      features: [
        'KPIs comerciales',
        'Predicciones de ventas',
        'Segmentación de mercado'
      ]
    }
  ];

  const handleProjectClick = (projectId) => {
    navigate(`/proyecto/${projectId}`);
  };

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            NUESTROS PROYECTOS
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explora nuestras soluciones y entra a cada módulo desde aquí.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
          {projects.map((p, index) => (
            <ProjectCard
              key={p.id}
              title={p.title}
              description={p.description}
              image={p.image}               // <— Aquí llega la imagen
              features={p.features}
              onClick={() => handleProjectClick(p.id)}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsGrid;